export default function($) {
  $('.input-file').each(function() {
    const inputFile = $(this)
    const fileNameElement = $(this).next('label').next('.input-file-name')
    const emptyText = fileNameElement.data('empty')

    inputFile.on('change', function() {
      const fileName = inputFile.val().split('\\').pop()
      fileNameElement.text(fileName ? fileName : emptyText)
    })
  })
}
